"use client"
import '@/styles/globals.css';
//import '@/styles/googleSearch.css';

import { useEffect, useState } from 'react';
import { Toaster } from "@/components/ui/toaster"
import { AlertDialogProvider } from "@/components/hooks/use-alert-dialog"
import { FirebaseInit } from '@/components/FirebaseInit'
import SessionTimeout from '@/components/SessionTimeout';
import { cn } from '@/lib/utils';
import OfflineNotification from '@/components/OfflineNotification';
import { AssistantCacheProvider } from '@/contexts/AssistantCacheContext';
import FirebaseService from '@/lib/firebase';
import { User } from 'firebase/auth';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const [currentUser, setCurrentUser] = useState<User | null>(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js') // Path to your service worker in the public folder
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    }
  }, []); // Empty dependency array ensures this runs once on mount

  // Auth listener at layout level
  useEffect(() => {
    const unsubscribe = FirebaseService.onAuthStateChange((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  return (
    <html lang="en">
      <head>
        {/* Existing meta tags */}
        <link rel="manifest" href="/manifest.json" />
        <meta name="theme-color" content="#FF8C00" />

        {/* iOS PWA specific tags */}
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Aitana" />

        {/* iOS icon links */}
        <link rel="apple-touch-icon" href="/images/logo/aitana-logo-192.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="/images/logo/aitana-ios-152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/images/logo/aitana-ios-180.png" />
        <link rel="apple-touch-icon" sizes="167x167" href="/images/logo/aitana-ios-167.png" />

        {/* iOS splash screens - you'll need to create these images */}
        <link
          rel="apple-touch-startup-image"
          media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)"
          href="/images/splash/iphone5_splash.png"
        />
        {/* Add more splash screen links for different device sizes */}
      </head>
      <body className={cn(
        'font-sans', // This will use your Tailwind font-sans configuration
        'bg-background min-h-screen'
      )}>
      <AlertDialogProvider>
        <AssistantCacheProvider currentUser={currentUser} fetchMessages={true} limit={10}>
          <SessionTimeout timeoutMinutes={15} warningMinutes={1} />
          <FirebaseInit />
          {children}
          <OfflineNotification />
          <Toaster />
        </AssistantCacheProvider>
      </ AlertDialogProvider>
      </body>
    </html>
  )
}